
namespace TabAurous.Inventory {
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class LotCreationDialog extends _Ext.TransDialog<LotCreationRow, any> {
        protected getFormKey() { return LotCreationForm.formKey; }
        protected getIdProperty() { return LotCreationRow.idProperty; }
        protected getLocalTextPrefix() { return LotCreationRow.localTextPrefix; }
        protected getNameProperty() { return LotCreationRow.nameProperty; }
        protected getService() { return LotCreationService.baseUrl; }
        protected getDeletePermission() { return LotCreationRow.deletePermission; }
        protected getInsertPermission() { return LotCreationRow.insertPermission; }
        protected getUpdatePermission() { return LotCreationRow.updatePermission; }

        protected form = new LotCreationForm(this.idPrefix);
        public Closing: boolean;
        public ItemSelected: LotCreationDetailsRow;
        constructor() {
            super();
            //Make grid full width
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 250;
            q.initItemEditor(this, this.form.Details, Config);
            q.initItemEditor(this, this.form.CommonItemDetails, Config);
            q.hideEditorLabel(this.form.Details);

            //q.hideCaption(this.form.Posted);
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFullWidth(this.form.Details);
            q.HideCategoryLable(this.element);


        }
        public setDataonAddClick(_entity:any,_AtbId:number,_Pieces:number,_NewSKU:number) {
            var items = [];
            if (this.form.CommonItemDetails.getItems().length > 0) {
                var Items = [];
                var AllowLotCreation = q.ToBool(TabAurous.GetConfigValue(1009)); 

                if (AllowLotCreation) {
                   items= this.form.CommonItemDetails.setData(_entity, _AtbId, _NewSKU);
                }
                else {
                    var pcs = _Pieces- this.form.CommonItemDetails.getItems().length;
                    if (pcs >= _NewSKU)
                        items =     this.form.CommonItemDetails.setData(_entity, _AtbId, _NewSKU);
                    //this.form.ItemsDetails.setItems(Items);
                    else if (pcs <= _NewSKU)
                        items =this.form.CommonItemDetails.setData(_entity, _AtbId, pcs);
                    else
                        Q.notifyError('Invalid Value(New SKU) should be less than Pieces');
                }

            }
            else {
                var AllowLotCreation = q.ToBool(TabAurous.GetConfigValue(1009));  

                if (AllowLotCreation) {
                    items =this.form.CommonItemDetails.setData(_entity, _AtbId, _NewSKU);
                }
                else {
                    if (_NewSKU <= _Pieces)
                        items =this.form.CommonItemDetails.setData(_entity, _AtbId, _NewSKU);
                    else
                        Q.notifyError('Invalid Value(New SKU) should be less than Pieces');
                }
            }
            this.setSplittingItemGrid(items); 
        } 
        public setSplittingItemGrid(items: any[]) {

            var lineno = this.ItemSelected.Line_No;
            var productid = this.ItemSelected.ProductId;
            var attributeid = this.ItemSelected.AttributeId;
            var sku = this.ItemSelected.SKU;
            var newitems = items;
            this.form.Details.setNewData(lineno, productid, attributeid, sku, newitems);
        }
        public setCommonGridData(items: any[]) {
            this.form.CommonItemDetails.setItems([]);
            this.form.CommonItemDetails._setData(items);
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            //var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            //var oldDeleteClick = btnDelete.onClick;
            //btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            ////Edit Click Override
            //var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            //var oldEditClick = btnEdit.onClick;
            //btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };


            var postingpermission = Q.Authorization.hasPermission('Inventory:LotCreation:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true;
                    delete entity.TransDate;
                     
                    for (var i = 0; i < entity.Details.length; i++) {
                        delete entity.Details[i].NewProductId;
                        delete entity.Details[i].NewProductCode;
                        delete entity.Details[i].NewPieces;
                        delete entity.Details[i].NewStoneWeight;
                        delete entity.Details[i].NewGrossWeight;
                        delete entity.Details[i].NewStoneWeight;
                    }
                    LotCreationService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });




            return btns;
        } 

        protected validateBeforeSave() {
            super.validateBeforeSave();
            var returnvalue = true;
            if (this.form.Details.getItems().length == null || this.form.Details.getItems().length == 0) {
                q.alert('', 'No Items Added', true, 2999);
                returnvalue = false;
            }
            if (returnvalue) {
                var details = this.form.Details.getItems();
                for (var d = 0; d < details.length; d++) {
                    if (returnvalue) {
                        var detail = details[d];
                        var items = detail.ItemsDetails;
                        for (var i = 0; i < items.length; i++) {
                            var item = items[i];
                            if (item.StoneWeight > 0) {
                                if (item.StoneRate <= 0) {
                                    q.Alert('', 'Stone Rate not set for ' + item.SKU + ' in ' + detail.ProductCode, 2999, true);
                                    returnvalue = false;
                                    return returnvalue;
                                }
                            }
                        }
                    }
                }
            }

            return returnvalue;
        }
    }
}